// src/components/DynamicReportInputs/DynamicParameterSelector.js
import React, { useState } from "react";
import { Grid, Typography, makeStyles } from "@material-ui/core";
import DistributorSelector from "./DistributorSelector";
import PeriodSelector from "./PeriodSelector";
import GenericSelector from "./GenericSelector";
import DateSelector from "./DateSelector";
import CycleSelector from "./CycleSelector";
import PharmacySelector from "components/CustomFields/PharmacySelector";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
    border: "1px solid #e0e0e0",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: "#fff",
  },
  title: {
    marginBottom: theme.spacing(2),
    fontWeight: 500,
    color: "#666",
  },
}));

const PROGRAM_OPTIONS = [
  { value: 1, label: "Receta Solidaria" },
  { value: 2, label: "Solo Mujer" },
  { value: 3, label: "GES" },
  { value: 4, label: "Mi Salcobrand" },
];

const PROGRAMS_RS_SM_OPTIONS = [
  { value: 1, label: "Receta Solidaria" },
  { value: 2, label: "Solo Mujer" },
];

const DISCOUNT_OPTIONS = [
  { value: 30, label: "30%" },
  { value: 40, label: "40%" },
  { value: 50, label: "50%" },
];


export default function DynamicParameterSelector({
  parameters,
  onParameterChange,
  requiredSelectors = [],
}) {
  const classes = useStyles();

  let fromPeriodError, toPeriodError, dateFromError, dateToError = null;

  if (parameters.from_period && parameters.to_period) {
    const fromVal = parseInt(parameters.from_period, 10);
    const toVal = parseInt(parameters.to_period, 10);
    if (fromVal > toVal) {
      fromPeriodError = "El periodo de inicio no puede ser mayor al periodo de fin";
      toPeriodError = "El periodo fin no puede ser menor al periodo de inicio";
    }
  }
  if (parameters.date_from && parameters.date_to) {
    const dateFrom = parseInt(parameters.date_from);
    const dateTo = parseInt(parameters.date_to);
    if (dateFrom > dateTo) {
      dateFromError = "La fecha de inicio no puede ser mayor a la fecha de fin";
      dateToError = "La fecha de fin no puede ser menor a la fecha de inicio";
    }
  }


  if (requiredSelectors.length === 0) {
    return <Typography color="textSecondary">Esta tarea no requiere parámetros adicionales.</Typography>;
  }

  return (
    <div className={classes.container}>
      <Typography variant="subtitle2" className={classes.title}>
        Parámetros requeridos
      </Typography>
      
      <Grid container spacing={3}>
        {requiredSelectors.includes("distributor_id") && (
          <Grid item xs={12} md={6}>
            <DistributorSelector
              value={parameters.distributor_id || ""}
              onChange={(newValue) => onParameterChange("distributor_id", newValue)}
              required={true}
            />
          </Grid>
        )}

        {requiredSelectors.includes("pharmacy_rut_with_vd") && (
          <Grid item xs={12} md={6}>
            <PharmacySelector
              value={parameters.pharmacy_rut || parameters.pharmacy_rut_with_vd || ""}
              onChange={(val) => onParameterChange("pharmacy_rut_with_vd", val)} 
              label="RUT Farmacia"
              placeholder="Nombre o RUT..."
              include_all={false}
              multiple={false}
              group_by_rut={true}
            />
          </Grid>
        )}


        {requiredSelectors.includes("from_period") && (
          <Grid item xs={12} md={6}>
            <PeriodSelector
              value={parameters.from_period || ""}
              onChange={(newValue) => onParameterChange("from_period", newValue)}
              required={true}
              label={"Periodo Desde"}
              error={fromPeriodError}
            />
          </Grid>
        )}

        {requiredSelectors.includes("to_period") && (
          <Grid item xs={12} md={6}>
            <PeriodSelector
              value={parameters.to_period || ""}
              onChange={(newValue) => onParameterChange("to_period", newValue)}
              required={true}
              label={"Periodo Hasta"}
              error={toPeriodError}
            />
          </Grid>
        )}

        {requiredSelectors.includes("program_id_rs_sm") && (
          <Grid item xs={12} md={6}>
            <GenericSelector
              label="Programa"
              value={parameters.program_id_rs_sm || ""}
              onChange={(newValue) => onParameterChange("program_id_rs_sm", newValue)}
              options={PROGRAMS_RS_SM_OPTIONS}
              required={true}
            />
          </Grid>
        )}

        {requiredSelectors.includes("program_id") && (
          <Grid item xs={12} md={6}>
            <GenericSelector
              label="Programa"
              value={parameters.program_id || ""}
              onChange={(newValue) => onParameterChange("program_id", newValue)}
              options={PROGRAM_OPTIONS}
              required={true}
            />
          </Grid>
        )}

        {requiredSelectors.includes("discount_percentage") && (
          <Grid item xs={12} md={6}>
            <GenericSelector
              label="Porcentaje de Descuento"
              value={parameters.discount_percentage || ""}
              onChange={(newValue) => onParameterChange("discount_percentage", newValue)}
              options={DISCOUNT_OPTIONS}
              required={true}
            />
          </Grid>
        )}

        {requiredSelectors.includes("date_from") && (
          <Grid item xs={12} md={6}>
            <DateSelector
              value={parameters.date_from || ""}
              onChange={(newValue) => onParameterChange("date_from", newValue)}
              required={true}
              label={"Fecha Desde"}
              error={dateFromError}
            />
          </Grid>
        )}

        {requiredSelectors.includes("date_to") && (
          <Grid item xs={12} md={6}>
            <DateSelector
              value={parameters.date_to || ""}
              onChange={(newValue) => onParameterChange("date_to", newValue)}
              required={true}
              label={"Fecha Hasta"}
              error={dateToError}
            />
          </Grid>
        )}

        {requiredSelectors.includes("cycle") && (
          <Grid item xs={12} md={6}>
            <CycleSelector
              value={parameters.cycle || ""}
              onChange={(newValue) => onParameterChange("cycle", newValue)}
              required={true}
            />
          </Grid>
        )}

      </Grid>
    </div>
  );
}